/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ModelVersions } from '../models/ModelVersions';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class GlmService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get a list of Model Versions from the GLM
   * @returns ModelVersions OK
   * @throws ApiError
   */
  public getModelVersions(): CancelablePromise<ModelVersions> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/motor/model-versions',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

}
